import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Rating } from 'models/order';
import { Box, Typography } from '@mui/material';
import { permissions } from 'utils/permission';
import { currentUserVar } from 'apollo/reactive-variables/user';

type RateOrderSectionProps = {
    rating: Rating;
};
const RateOrderSection: FC<RateOrderSectionProps> = ({ rating }: RateOrderSectionProps) => {
    const { t: translate } = useTranslation(['orders']);
    const currentUser = currentUserVar();
    // DD-3391: this used to read the lab-wide LIMIT_INFO_EXTERNAL_USERS setting with
    // no role check at all, so switching it on hid "Rated by" from everyone in the
    // lab, internal staff included. Only the restricted tier should lose it.
    const isRestrictedExternalUser = permissions.isRestrictedExternalUser(currentUser?.role);
    return (
        <Fragment>
            <Box>
                {!isRestrictedExternalUser ? (
                    <Box display="flex">
                        <Box mr={1}>
                            <Typography variant="subtitle2">{translate('orders:RATED_BY')}:</Typography>
                        </Box>
                        <Box>{rating.by.fullName}</Box>
                    </Box>
                ) : undefined}
                <Box display="flex">
                    <Box mr={1}>
                        <Typography variant="subtitle2">{translate('orders:RATING')}:</Typography>
                    </Box>
                    <Box>{rating.satisfied ? translate('orders:SATISFIED') : translate('orders:NOT_SATISFIED')}</Box>
                </Box>
                {rating.notSatisfied ? (
                    <Box display="flex">
                        <Box mr={1}>
                            <Typography variant="subtitle2">{translate('orders:REMARKS')}:</Typography>
                        </Box>
                        <Box>
                            {rating.reasons
                                .filter((reason) => reason.value)
                                .map((content) => translate(`orders:${content.name}`))
                                .join(', ')}
                        </Box>
                    </Box>
                ) : undefined}
                {rating.comments ? (
                    <Box display="flex">
                        <Box mr={1}>
                            <Typography variant="subtitle2">{translate('orders:COMMENT')}:</Typography>
                        </Box>
                        <Box>{rating.comments}</Box>
                    </Box>
                ) : undefined}
            </Box>
        </Fragment>
    );
};

export default RateOrderSection;
